import React, { useState } from "react";
import {Fab,makeStyles,createStyles,Theme, Box} from "@material-ui/core";
import MailOutlineIcon from "@material-ui/icons/MailOutline";
import FileCopyOutlinedIcon from "@material-ui/icons/FileCopyOutlined";

interface FloatingButtonPropsInterface {
    mobileText:string;
    text:string;
    clickCallback:()=>void;
}

const useStyles =  makeStyles((theme: Theme) =>
    createStyles({
        root: {
            '& > *': {
              margin: theme.spacing(1),
            },
          },
          extendedIcon: {
            marginRight: theme.spacing(1),
          },

        floatingButton: {
            color:"#FFFFFF",
            borderRadius: "24px",
            position: "fixed",
            bottom: theme.spacing(2),
            right: theme.spacing(2),
      },
      isVisible:{
        marginRight:"5px",
        display:"visible",
        [theme.breakpoints.down('sm')]: {
          display:"none"
        },
      }  
    }),
);


const FloatingButton:React.FunctionComponent<FloatingButtonPropsInterface> = (props)=>{

const classes = useStyles();
const blue = "#2F80ED";
const green = "#6FCF97";
const [color,setColor] = useState(blue);
const [dispayCopied,setDisplayCopied] = useState(false);
const [icon,setIcon] = useState(<MailOutlineIcon className={classes.extendedIcon} />);

const emailDisplay = props.text !== "Support"? (<u>{props.text}</u>) : props.text;

const handleClick = ()=>{
  props.clickCallback();

  if(color === blue){
    setColor(green);
    setIcon(<FileCopyOutlinedIcon className={classes.extendedIcon} />);
    setDisplayCopied(true);
  } else{
    setDisplayCopied(false);
    setColor(blue);
    setIcon(<MailOutlineIcon className={classes.extendedIcon} />);
  }
}

return(
    <Fab color="secondary" onClick={handleClick} className={classes.floatingButton} style={{backgroundColor:color,textTransform:"none"}} variant="extended">
       {icon} {dispayCopied && <Box component="span" className={classes.isVisible}>{props.mobileText}</Box>} {emailDisplay}
    </Fab>
)
};

export default FloatingButton;